import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2c98547a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "row no-wrap items-start justify-between q-mt-sm q-col-gutter-x-md" }
const _hoisted_2 = {
  key: 0,
  class: "q-mt-xs"
}
const _hoisted_3 = { class: "q-ml-xs" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_iap_input_number = _resolveComponent("iap-input-number")!
  const _component_q_icon = _resolveComponent("q-icon")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_iap_input_number, {
        class: "col",
        modelValue: _ctx.minNumber,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.minNumber) = $event)),
        placeholder: _ctx.t('ENTER_NUMBER'),
        "label-slot": ""
      }, {
        label: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.t('MIN')), 1)
        ]),
        _: 1
      }, 8, ["modelValue", "placeholder"]),
      _createVNode(_component_iap_input_number, {
        class: "col number-range-max",
        modelValue: _ctx.maxNumber,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.maxNumber) = $event)),
        placeholder: _ctx.t('ENTER_NUMBER'),
        onBlur: _cache[2] || (_cache[2] = ($event: any) => (_ctx.bufferMaxNumber = null)),
        "label-slot": ""
      }, {
        label: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.t('MAX')), 1)
        ]),
        _: 1
      }, 8, ["modelValue", "placeholder"])
    ]),
    (_ctx.UnValidMaxNumber)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_q_icon, {
            color: "negative",
            name: _ctx.ICONS_NAME.WARNING_SOLID
          }, null, 8, ["name"]),
          _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.t('NUMBER_VALIDATION')), 1)
        ]))
      : _createCommentVNode("", true)
  ], 64))
}